import React from 'react'
import { Title, Text } from 'components/typo'
import Button from 'components/shared/Button'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

import Link from 'components/shared/Link'

const cx = classnames.bind(css)

const BlogCloudCTA = ({ className, title, text }) => {
  return (
    <div id="editor-pick-card" className={cx(className, css.BlogCloudCTA)}>
      <div className={css.topPattern} />
      <div className={css.bottomPattern} />
      <div className={css.content}>
        {title && (
          <Title className={css.title} theme="white" size="small">
            {title}
          </Title>
        )}
        {text && (
          <Text className={css.text} theme="white" size="small">
            {text}
          </Text>
        )}
        <Link
          href="https://hubs.la/Q022mRNT0"
          target="_blank"
          id="blog-cloud-cta"
        >
          <Button
            id="blog-cloud-cta-button"
            href="https://hubs.la/Q022mRNT0"
            tagName="button"
            className={css.button}
            fullWidth
            theme="white-blue-500"
          >
            Free Trial
          </Button>
        </Link>
      </div>
    </div>
  )
}

BlogCloudCTA.defaultProps = {}

export default BlogCloudCTA
